import styled from "../../styles/styled-components";
import { TeamProps } from "./Team";
import { mediaQueries } from "../../styles/media-queries";
import { PlayerStyle } from "../Player/PlayerStyle";

const TeamStyle = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	align-items: center;
	flex: 1;
	// max-width: 975px;
	height: 100%;
	background: url(${(props: TeamProps) => props.bg}) no-repeat center center/120% 100%;
	padding: 40px 0;

	.position {
		z-index: 10;
		margin-top: 10px;
		display: flex;
		width: 100%;
		justify-content: center;
		flex-wrap: wrap;
		-webkit-box-pack: center;
		
		@media ${mediaQueries.tablet} {
			flex-wrap: nowrap;
		}

		${PlayerStyle} {
			margin: 12px;

			@media ${mediaQueries.tablet} {
				margin: 0 12px;
			}
		}
	}
	
	@media ${mediaQueries.tablet} {
		// max-width: 860px;
		height: ${(props: TeamProps) => (props.heightRatio / props.widthRatio) * 630}px;
		background-size: 100% 100%;
	}
` as any;

interface SponsorProps {
	bg: string;
	widthRatio: number;
	heightRatio: number;
}
const Sponsor = styled.div`
	position: absolute;
	top: ${(props:SponsorProps) => (props.heightRatio / props.widthRatio) * 8}px;
	left: 0;
	right: 0;
	height: ${(props:SponsorProps) => (props.heightRatio / props.widthRatio) * 30}px;
	background-color: rgba(255,0,0,0.5);
	background: ${(props: SponsorProps) => `url(${props.bg})`} no-repeat center center/contain;
	transform: scale(0.8);

	@media ${mediaQueries.mobileM} {
		top: ${(props:SponsorProps) => (props.heightRatio / props.widthRatio) * 12}px;
		height: ${(props:SponsorProps) => (props.heightRatio / props.widthRatio) * 28}px;
	}

	@media ${mediaQueries.tablet} {
		top: ${(props:SponsorProps) => (props.heightRatio / props.widthRatio) * 15}px;
		height: ${(props:SponsorProps) => (props.heightRatio / props.widthRatio) * 30}px;
	}
`;

export {
	TeamStyle,
	Sponsor
};